import { useState, useCallback } from "react";
import { GAMES } from "./useLists";
import { save } from "./stamps";

const GAME_KEY = "ppt_game_v1";

/**
 * Which game the whole app is looking at.
 *
 * One Piece used to be its own section, which meant every screen the app has —
 * pricing a stack, a single card, the collection — quietly belonged to Pokemon
 * and One Piece got a cut-down corner. The screens are the same shape for both
 * games, so the game became a mode instead: one set of screens, one switch.
 *
 * Remembered, because whichever game you collect is not a per-visit decision.
 */
export default function useGame() {
  const [game, setGameState] = useState(() => {
    try {
      const saved = window.localStorage.getItem(GAME_KEY);
      return saved === GAMES.ONE_PIECE || saved === GAMES.POKEMON ? saved : GAMES.POKEMON;
    } catch {
      return GAMES.POKEMON;
    }
  });

  const setGame = useCallback((next) => {
    if (next !== GAMES.POKEMON && next !== GAMES.ONE_PIECE) return;
    setGameState(next);
    try {
      save(GAME_KEY, next);
    } catch {
      /* a blocked localStorage shouldn't break the switch */
    }
  }, []);

  return {
    game,
    setGame,
    isOnePiece: game === GAMES.ONE_PIECE,
    /* What the current game can actually answer. Stated here rather than
       checked ad hoc in five places, so a screen that has to say "not for this
       game" says it from one source. */
    hasGradedPrices: game === GAMES.POKEMON,
    hasConditions: game === GAMES.POKEMON,
  };
}
